var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMlp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.163,59.963c-1.682,0-3.228,0.594-4.441,1.581L40.163,50.177c0.019-0.059,0.037-0.118,0.055-0.177h15.565 c0.865,2.918,3.567,5.055,6.762,5.055c3.89,0,7.055-3.165,7.055-7.055c0-3.89-3.165-7.055-7.055-7.055 c-3.195,0-5.897,2.136-6.762,5.055H40.218c-0.018-0.059-0.035-0.119-0.055-0.177l16.559-11.366 c1.214,0.987,2.759,1.581,4.441,1.581c3.89,0,7.055-3.165,7.055-7.055s-3.165-7.055-7.055-7.055s-7.054,3.165-7.054,7.055 c0,0.76,0.124,1.491,0.348,2.177L37.898,42.526c-1.214-0.987-2.759-1.581-4.442-1.581c-3.89,0-7.054,3.165-7.054,7.055 c0,3.89,3.165,7.055,7.054,7.055c1.683,0,3.228-0.594,4.442-1.581l16.559,11.367c-0.223,0.686-0.347,1.417-0.347,2.177 c0,3.89,3.164,7.055,7.054,7.055s7.055-3.165,7.055-7.055S65.053,59.963,61.163,59.963z M62.544,44.945 c1.685,0,3.055,1.37,3.055,3.055s-1.37,3.055-3.055,3.055s-3.055-1.37-3.055-3.055S60.859,44.945,62.544,44.945z M61.163,25.928 c1.685,0,3.055,1.37,3.055,3.055s-1.37,3.055-3.055,3.055c-1.684,0-3.054-1.37-3.054-3.055S59.479,25.928,61.163,25.928z  M33.456,51.055c-1.684,0-3.054-1.37-3.054-3.055s1.37-3.055,3.054-3.055c1.685,0,3.055,1.37,3.055,3.055 S35.141,51.055,33.456,51.055z M61.163,70.072c-1.684,0-3.054-1.37-3.054-3.055s1.37-3.055,3.054-3.055 c1.685,0,3.055,1.37,3.055,3.055S62.848,70.072,61.163,70.072z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlp);
export default __webpack_public_path__ + "static/media/mlp.252109fa78900eef5fb89f56b1689806.svg";
export { ForwardRef as ReactComponent };